import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    dashboardStats: {},
    attendanceStats: {},
    loading: false,
    error: null,
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboardStats: (state, action) => {
            state.dashboardStats = action.payload;
        },
        setAttendanceStats: (state, action) => {
            state.attendanceStats = action.payload;
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setDashboardStats, setAttendanceStats } = dashboardSlice.actions;

export default dashboardSlice.reducer;